import React, { useState } from "react";

import { graphql, useMutation } from "react-relay";

import { IntegrationSoftOneCreateScreenMutation } from "./__generated__/IntegrationSoftOneCreateScreenMutation.graphql";
import { useAlert } from "../../common/Alert";

import { StoreAdminNavigationScreenProps } from "../StoreAdmin/StoreAdminNavigation";
import { IntegrationActivateScreen } from "./components/IntegrationActivation";
import { FormattedMessage } from "react-intl";
import { IntegrationSoftOneCreateScreenOrgMutation } from "./__generated__/IntegrationSoftOneCreateScreenOrgMutation.graphql";
import { IntegrationLogo } from "./components/Logos/Logos";

export function IntegrationSoftOneCreateScreen(
  props: StoreAdminNavigationScreenProps<"IntegrationSoftOneCreate">
) {
  const [companyApiKey, setCompanyApiKey] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const [addMutation, pending] =
    useMutation<IntegrationSoftOneCreateScreenMutation>(graphql`
      mutation IntegrationSoftOneCreateScreenMutation(
        $companyApiKey: String!
        $password: String!
        $username: String!
      ) {
        store {
          activateIntegrationSoftOne(
            companyApiKey: $companyApiKey
            password: $password
            username: $username
          ) {
            id
          }
        }
      }
    `);

  const Alert = useAlert();
  const add = () => {
    if (pending) {
      return;
    }
    addMutation({
      onError: () => {
        Alert.error("Fel inträffade");
      },
      onCompleted: (v) => {
        props.navigation.goBack();
      },
      variables: {
        companyApiKey,
        password,
        username: username.includes("api.storesprint")
          ? username
          : "api.storesprint@" + username,
      },
    });
  };

  return (
    <IntegrationActivateScreen
      header={
        <IntegrationActivateScreen.Header
          logo={<IntegrationLogo type="softone" />}
          button={
            <IntegrationActivateScreen.Header.Link link="https://storesprint.com/support/direct/softone" />
          }
        />
      }
      activation={
        <>
          <IntegrationActivateScreen.Input
            value={companyApiKey}
            onChangeText={setCompanyApiKey}
            type="api-key"
          />
          <IntegrationActivateScreen.Input
            value={username}
            onChangeText={setUsername}
            type="username"
            label={
              <FormattedMessage
                description="IntegrationsAdminSoftOne create screen instruction"
                defaultMessage="License number"
              />
            }
            placeholder="api.storesprint@licensnummer"
          />
          <IntegrationActivateScreen.Input
            value={password}
            onChangeText={setPassword}
            type="password"
          />
        </>
      }
      onActivate={add}
      isValid={companyApiKey !== "" && username !== "" && password !== ""}
      isActivating={pending}
    />
  );
}

export function IntegrationSoftOneOrgCreateScreen(
  props: StoreAdminNavigationScreenProps<"IntegrationSoftOneOrgCreate">
) {
  const [accountIds, setAccountIds] = useState("");

  const [addMutation, pending] =
    useMutation<IntegrationSoftOneCreateScreenOrgMutation>(graphql`
      mutation IntegrationSoftOneCreateScreenOrgMutation($accountIds: [ID!]!) {
        store {
          activateIntegrationSoftOneOrg(accountIds: $accountIds) {
            id
          }
        }
      }
    `);

  const Alert = useAlert();
  const add = () => {
    if (pending) {
      return;
    }
    addMutation({
      onError: () => {
        Alert.error("Error activating integration");
      },
      onCompleted: (v) => {
        props.navigation.goBack();
      },
      variables: {
        accountIds: accountIds.split(",").map((id) => id.trim()),
      },
    });
  };

  return (
    <IntegrationActivateScreen
      header={
        <IntegrationActivateScreen.Header
          logo={<IntegrationLogo type="softone" />}
          button={
            <IntegrationActivateScreen.Header.Link link="https://storesprint.com/support/direct/softone" />
          }
        />
      }
      activation={
        <>
          <IntegrationActivateScreen.Input
            value={accountIds}
            onChangeText={setAccountIds}
            type="api-key"
            placeholder="account ids separated by commas"
          />
        </>
      }
      onActivate={add}
      isValid={accountIds !== ""}
      isActivating={pending}
    />
  );
}
